import React from 'react';
import {
    ChevronRight,
    Clock,
    Lock,
    Users,
    Dumbbell,
    Shield,
    Calendar,
    CheckCircle,
    Star,
    DollarSign,
    Camera,
    MessageCircle
} from 'lucide-react';
import {ReactBrick} from "@olympeio/core";
import {combineLatest} from "rxjs";
import { registerBrick } from 'olympe';


export default class LandingPage extends ReactBrick {

    /**
     * @override
     */
    setupExecution($) {
        return combineLatest([
            $.observe('Hidden', false),
        ]);
    }
    /**
     * @override
     */
    static getReactComponent($) {
        return (props) => {

            const benefits = [
                {
                    title: "Complete Privacy",
                    description: "Work out without distractions in your own private space. Perfect for those who prefer focused, uninterrupted training sessions.",
                    icon: <Lock className="w-6 h-6 text-indigo-500"/>
                },
                {
                    title: "24/7 Access",
                    description: "Book the room whenever suits your schedule, day or night. Early morning or late evening workouts? No problem!",
                    icon: <Clock className="w-6 h-6 text-indigo-500"/>
                },
                {
                    title: "Exclusive Equipment",
                    description: "High-quality equipment all to yourself, from cardio machines to free weights. No waiting, no sharing.",
                    icon: <Dumbbell className="w-6 h-6 text-indigo-500"/>
                },
                {
                    title: "Bring Friends",
                    description: "Share the space with friends or family. Perfect for private group workouts or personal training sessions.",
                    icon: <Users className="w-6 h-6 text-indigo-500"/>
                }
            ];

            const equipment = [
                "Professional Power Rack",
                "Olympic Barbell Set",
                "Adjustable Benches",
                "Premium Cardio Equipment",
                "Full Dumbbell Range",
                "Kettlebells & Medicine Balls",
                "Yoga/Stretching Area",
                "Boxing Equipment"
            ];

            const testimonials = [
                {
                    name: "Sarah M.",
                    role: "Fitness Enthusiast",
                    comment: "Having a private space to work out has completely transformed my fitness routine. No more waiting for equipment or feeling self-conscious!",
                    rating: 5
                },
                {
                    name: "Mike R.",
                    role: "Personal Trainer",
                    comment: "I bring my clients here for focused, distraction-free sessions. The equipment quality and privacy are unmatched.",
                    rating: 5
                },
                {
                    name: "Lisa K.",
                    role: "Yoga Instructor",
                    comment: "Perfect space for my private yoga sessions. The atmosphere is so peaceful and the room is always spotlessly clean.",
                    rating: 5
                }
            ];

            const pricingPlans = [
                {
                    name: "Single Session",
                    price: "$25/hour",
                    features: [
                        "Full room access",
                        "All equipment included",
                        "Flexible scheduling",
                        "No commitment"
                    ]
                },
                {
                    name: "Weekly Pass",
                    price: "$150/week",
                    features: [
                        "Unlimited access",
                        "Priority booking",
                        "Bring a friend free",
                        "Schedule up to 2 weeks ahead"
                    ]
                },
                {
                    name: "Monthly Premium",
                    price: "$499/month",
                    features: [
                        "Unlimited access",
                        "VIP priority booking",
                        "Free towel service",
                        "Personal locker",
                        "Schedule up to 1 month ahead"
                    ]
                }
            ];

            return (
                <div className="w-full h-full overflow-y-auto">
                    {/* Hero Section */}
                    <div className="relative overflow-hidden">
                        <div className="max-w-7xl mx-auto">
                            <div className="relative z-10 pb-8 bg-white sm:pb-16 md:pb-20 lg:pb-28 xl:pb-32">
                                <main
                                    className="mt-10 mx-auto max-w-7xl px-4 sm:mt-12 sm:px-6 md:mt-16 lg:mt-20 xl:mt-28">
                                    <div className="text-center lg:text-left">
                                        <h1 className="text-4xl tracking-tight font-extrabold text-gray-900 sm:text-5xl md:text-6xl">
                                            <span className="block">Your Private</span>
                                            <span className="block text-indigo-500">Fitness Sanctuary</span>
                                        </h1>
                                        <p className="mt-3 text-base text-gray-500 sm:mt-5 sm:text-lg sm:max-w-xl sm:mx-auto md:mt-5 md:text-xl lg:mx-0">
                                            Experience the ultimate workout freedom. Rent your private fitness room and
                                            exercise on your own terms, with all the equipment you need.
                                        </p>
                                        <div className="mt-5 sm:mt-8 sm:flex sm:justify-center lg:justify-start">
                                            <div className="rounded-md shadow">
                                                <button
                                                    className="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-white bg-indigo-500 hover:bg-indigo-600 md:py-4 md:text-lg md:px-10">
                                                    Book Now
                                                    <ChevronRight className="ml-2 w-5 h-5"/>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </main>
                            </div>
                        </div>
                    </div>

                    {/*<svg*/}
                    {/*    viewBox="0 0 1440 120"*/}
                    {/*    xmlns="http://www.w3.org/2000/svg"*/}
                    {/*    className="w-full"*/}
                    {/*    preserveAspectRatio="none"*/}
                    {/*>*/}
                    {/*    <path*/}
                    {/*        d="M0,32L60,42.7C120,53,240,75,360,74.7C480,75,600,53,720,58.7C840,64,960,96,1080,106.7C1200,117,1320,107,1380,101.3L1440,96L1440,120L1380,120C1320,120,1200,120,1080,120C960,120,840,120,720,120C600,120,480,120,360,120C240,120,120,120,60,120L0,120Z"*/}
                    {/*        fill="rgb(238, 242, 255)" // Tailwind's lighter indigo tone (bg-indigo-50)*/}
                    {/*    ></path>*/}
                    {/*</svg>*/}
                    {/*<svg*/}
                    {/*    viewBox="0 0 1440 400"*/}
                    {/*    xmlns="http://www.w3.org/2000/svg"*/}
                    {/*    className="w-full"*/}
                    {/*    preserveAspectRatio="none"*/}
                    {/*>*/}
                    {/*    /!* Wave 1 *!/*/}
                    {/*    <path*/}
                    {/*        d="M0,80 C180,160 360,40 540,80 C720,120 900,200 1080,160 C1260,120 1440,200 1440,200 L1440,0 L0,0 Z"*/}
                    {/*        fill="rgba(224, 231, 255, 1)" // Light indigo color*/}
                    {/*    />*/}
                    {/*    /!* Wave 2 *!/*/}
                    {/*    <path*/}
                    {/*        d="M0,160 C240,240 480,120 720,200 C960,280 1200,160 1440,240 L1440,0 L0,0 Z"*/}
                    {/*        fill="rgba(199, 210, 254, 0.8)" // Slightly darker with transparency*/}
                    {/*    />*/}
                    {/*    /!* Wave 3 *!/*/}
                    {/*    <path*/}
                    {/*        d="M0,240 C300,300 600,180 900,260 C1200,340 1440,220 1440,220 L1440,0 L0,0 Z"*/}
                    {/*        fill="rgba(174, 185, 255, 0.6)" // A bit darker with more transparency*/}
                    {/*    />*/}
                    {/*    /!* Wave 4 *!/*/}
                    {/*    <path*/}
                    {/*        d="M0,300 C200,360 400,280 600,320 C800,360 1000,280 1200,340 C1400,400 1440,360 1440,360 L1440,400 L0,400 Z"*/}
                    {/*        fill="rgba(148, 163, 254, 0.4)" // Darkest with the most transparency*/}
                    {/*    />*/}
                    {/*</svg>*/}
                    <svg
                        viewBox="0 0 1440 300"
                        xmlns="http://www.w3.org/2000/svg"
                        className="w-full"
                        preserveAspectRatio="none"
                    >
                        {/* Top-Oriented Wave 1  */}
                        <path
                            d="M0,60 C240,100 480,20 720,80 C960,140 1200,60 1440,100 L1440,150 L0,150 Z"
                            fill="rgba(174, 185, 255, 0.6)" // A bit darker with more transparency
                        />
                        {/* Top-Oriented Wave 2  */}
                        <path
                            d="M0,20 C200,60 400,-20 600,120 C800,100 1000,20 1200,80 C1400,120 1440,100 1440,100 L1440,150 L0,150 Z"
                            fill="rgba(148, 163, 254, 0.4)" // Darkest with the most transparency
                        />

                        {/* Bottom-Oriented Wave 1  */}
                        <path
                            d="M0,240 C240,50 480,280 720,220 C960,160 1200,240 1440,200 L1440,150 L0,150 Z"
                            fill="rgba(174, 185, 255, 0.6)" // A bit darker with more transparency
                        />
                        {/* Bottom-Oriented Wave 2 */}
                        <path
                            d="M0,200 C200,160 400,240 600,180 C800,120 1000,200 1200,140 C1400,100 1440,120 1440,120 L1440,150 L0,150 Z"
                            fill="rgba(148, 163, 254, 0.4)" // Darkest with the most transparency
                        />
                    </svg>

                    {/* Virtual Tour Section */}
                    <div className="bg-gray-50 py-16">
                        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                            <div className="text-center">
                                <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">
                                    Take a Virtual Tour
                                </h2>
                                <p className="mt-4 text-lg text-gray-500">
                                    Explore our state-of-the-art facility before your first visit
                                </p>
                            </div>
                            <div className="mt-10 bg-white rounded-lg shadow-lg overflow-hidden">
                                <div
                                    className="aspect-w-16 aspect-h-9 bg-gray-200 flex items-center justify-center min-h-[400px]">
                                    <div className="text-center">
                                        <Camera className="w-16 h-16 text-gray-400 mx-auto"/>
                                        <p className="text-gray-500 mt-4">360° Virtual Tour Placeholder</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Benefits Section */}
                    <div className="py-12 bg-white">
                        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                            <div className="lg:text-center">
                                <h2 className="text-base text-indigo-500 font-semibold tracking-wide uppercase">Benefits</h2>
                                <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                                    Why Choose Private Fitness?
                                </p>
                            </div>

                            <div className="mt-10">
                                <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
                                    {benefits.map((benefit, index) => (
                                        <div key={index}
                                             className="flex flex-col items-center p-6 bg-white rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300">
                                            <div
                                                className="flex items-center justify-center h-12 w-12 rounded-md bg-indigo-50 text-white">
                                                {benefit.icon}
                                            </div>
                                            <h3 className="mt-5 text-lg leading-6 font-medium text-gray-900">
                                                {benefit.title}
                                            </h3>
                                            <p className="mt-2 text-base text-gray-500 text-center">
                                                {benefit.description}
                                            </p>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Equipment Section */}
                    <div className="bg-indigo-50 py-16">
                        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                            <div className="text-center">
                                <h2 className="text-3xl font-extrabold text-gray-900">
                                    Premium Equipment
                                </h2>
                                <p className="mt-4 text-lg text-gray-500">
                                    Everything you need for a complete workout experience
                                </p>
                            </div>
                            <div className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
                                {equipment.map((item, index) => (
                                    <div key={index} className="bg-white p-6 rounded-lg shadow-md flex items-center">
                                        <CheckCircle className="w-5 h-5 text-indigo-500 mr-3"/>
                                        <span className="text-gray-700">{item}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* Pricing Section */}
                    <div className="py-16 bg-white">
                        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                            <div className="text-center">
                                <h2 className="text-3xl font-extrabold text-gray-900">
                                    Flexible Pricing Plans
                                </h2>
                                <p className="mt-4 text-lg text-gray-500">
                                    Choose the plan that best fits your needs
                                </p>
                            </div>
                            <div className="mt-10 grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
                                {pricingPlans.map((plan, index) => (
                                    <div key={index} className="bg-white rounded-lg shadow-lg overflow-hidden">
                                        <div className="px-6 py-8">
                                            <h3 className="text-2xl font-bold text-gray-900">{plan.name}</h3>
                                            <p className="mt-4 text-3xl font-bold text-indigo-500">{plan.price}</p>
                                            <ul className="mt-6 space-y-4">
                                                {plan.features.map((feature, featureIndex) => (
                                                    <li key={featureIndex} className="flex items-center">
                                                        <CheckCircle className="w-5 h-5 text-indigo-500 mr-3"/>
                                                        <span className="text-gray-600">{feature}</span>
                                                    </li>
                                                ))}
                                            </ul>
                                            <button
                                                className="mt-8 w-full bg-indigo-500 text-white py-3 px-4 rounded-md hover:bg-indigo-600 transition-colors duration-300">
                                                Select Plan
                                            </button>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* Testimonials Section */}
                    <div className="bg-gray-50 py-16">
                        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                            <div className="text-center">
                                <h2 className="text-3xl font-extrabold text-gray-900">
                                    What Our Members Say
                                </h2>
                            </div>
                            <div className="mt-10 grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
                                {testimonials.map((testimonial, index) => (
                                    <div key={index} className="bg-white rounded-lg shadow-lg p-6">
                                        <div className="flex items-center mb-4">
                                            {[...Array(testimonial.rating)].map((_, i) => (
                                                <Star key={i} className="w-5 h-5 text-yellow-400"/>
                                            ))}
                                        </div>
                                        <p className="text-gray-600 italic mb-4">"{testimonial.comment}"</p>
                                        <div className="font-medium">
                                            <p className="text-gray-900">{testimonial.name}</p>
                                            <p className="text-indigo-500">{testimonial.role}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* FAQ Section */}
                    <div className="bg-white py-16">
                        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                            <div className="text-center">
                                <h2 className="text-3xl font-extrabold text-gray-900">
                                    Frequently Asked Questions
                                </h2>
                            </div>
                            <div className="mt-10 max-w-3xl mx-auto">
                                <div className="space-y-8">
                                    <div>
                                        <h3 className="text-lg font-medium text-gray-900">How do I book the fitness
                                            room?</h3>
                                        <p className="mt-2 text-gray-500">Booking is simple through our online system.
                                            Select your preferred time slot, make the payment, and you'll receive
                                            instant confirmation.</p>
                                    </div>
                                    <div>
                                        <h3 className="text-lg font-medium text-gray-900">What happens if I need to
                                            cancel?</h3>
                                        <p className="mt-2 text-gray-500">Cancellations made 24 hours in advance receive
                                            a full refund. Late cancellations may be subject to a fee.</p>
                                    </div>
                                    <div>
                                        <h3 className="text-lg font-medium text-gray-900">Is there a shower
                                            facility?</h3>
                                        <p className="mt-2 text-gray-500">Yes, we provide private shower facilities with
                                            towel service for our premium members.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Contact Section */}
                    <div className="bg-indigo-50 py-16">
                        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                            <div className="text-center">
                                <h2 className="text-3xl font-extrabold text-gray-900">
                                    Get in Touch
                                </h2>
                                <p className="mt-4 text-lg text-gray-500">
                                    Have questions? We're here to help!
                                </p>
                            </div>
                            <div className="mt-10 max-w-xl mx-auto">
                                <div className="grid grid-cols-1 gap-6">
                                    <button
                                        className="flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-white bg-indigo-500 hover:bg-indigo-600">
                                        <MessageCircle className="w-5 h-5 mr-2"/>
                                        Contact Us
                                    </button>
                                    <div className="text-center text-gray-500">
                                        <p>Email: info@privatefitness.com</p>
                                        <p>Phone: (555) 123-4567</p>
                                        <p>Location: 123 Fitness Street, Workout City</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
    }
};

registerBrick('0194597ab0a6f831555c', LandingPage);